<div class="image-placeholder">
    <i class="dku-loader icon-spin dku-loader--inlined" [ngStyle]="{ 'width': calculatedSize / 5 + 'px', 'height': calculatedSize / 5 + 'px' }" *ngIf="!hasLoaded"></i>
    <ng-container *ngIf="hasLoaded">
        <i class="icon-picture" [ngStyle]="{ 'font-size': calculatedSize / 3 + 'px' }"></i>
        <p class="image-placeholder__message" *ngIf="noImageMessage">
            {{ noImageMessage }}
        </p>
    </ng-container>
</div>
